import { combineReducers } from "redux";
import contact from "../features/admin/contactus/contact/Slice";
import call_contactus from "../features/admin/contactus/call_contactus/Slice";

const contactus = combineReducers({
  contact: contact,
  call_contactus: call_contactus,
});

export default contactus;
